<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-bug"></i> {{ _('Issue') }} {{ issue.id }}</h3>
          <span class="subtitle">{{ $filters.timestampToDate(issue.ts) }} {{ _('at') }} {{ $filters.timestampToTime(issue.ts) }}</span>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <div class="row" v-if="issue">
        <div class="col-md-12">
          <hr/>
          <h3>{{ _('General') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 leftcol">
          <div class="form-group">
            <label for="type">{{ _('Type') }}</label>
            <p>{{ getIssueType(issue.type) }}</p>
          </div>
          <div class="form-group">
            <label for="type">{{ _('Status') }}</label>
            <p v-if="parseInt(issue.status) === this.STATUS_ACKNOWLEDGED">{{ _('Acknowledged') }}</p>
            <p v-else>{{ _('Not acknowledged') }}</p>
          </div>
          <div class="form-group" v-if="issue.reftype && issue.ref && !parseInt(issue.emailmerchantcopy)">
            <label for="type">{{ _('Related item') }}</label>
            <p v-if="issue.reftype === 'email'"><button class="btn btn-primary" v-on:click="openRef"><i class="fa fa-fw fa-envelope"></i> {{ _('Email') }}</button></p>
            <p v-else><a href="javascript:;" v-on:click="openRef">{{ issue.reftype }} {{ issue.ref }}</a></p>
          </div>
          <div class="form-group" v-if="issue.message">
            <label for="message">{{ _('Message') }}</label>
            <p class="issue-message">{{ issue.message }}</p>
          </div>
          <div class="form-group" v-if="issue.type === 'email' && issue.bouncename">
            <label>{{ _('Bounce details') }}</label>
            <div class="well">
              <div class="bounce-detail">
                <strong>{{ _('Bounce type') }}</strong><br>{{ issue.bouncename }}
              </div>
              <div class="bounce-detail" v-if="issue.bouncedescription">
                <strong>{{ _('Description') }}</strong><br>{{ issue.bouncedescription }}
              </div>
              <div class="bounce-detail" v-if="issue.bouncesubject">
                <strong>{{ _('Message subject') }}</strong><br>{{ issue.bouncesubject }}
              </div>
              <div class="bounce-detail" v-if="issue.bounceemail">
                <strong>{{ _('Recipient') }}</strong><br>{{ issue.bounceemail }}
              </div>
              <div v-if="issue.emailorder">
                <button class="btn btn-primary" v-on:click="openOrder(issue.emailorder)"><i class="fa fa-fw fa-shopping-cart"></i> {{ _('Order') }} {{ issue.emailorder }}</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="creator">{{ _('Creator') }}</label>
            <p>{{ issue.creator }}</p>
          </div>
        </div>
        <div class="col-sm-6 rightcol">
          <div class="form-group">
            <label for="message">{{ _('Raw data') }}</label><br />
            <div class="well">
              <code v-if="issue.jsondata">{{ JSON.parse(issue.jsondata) }}</code>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row space-between">
        <button class="btn btn-success" v-on:click="acknowledge" :disabled="!isAckButtonEnabled"><i class="fa fa-fw fa-check"></i> {{ _('Acknowledge issue') }}</button>
        <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import { SentMessageDetails } from '#components'

export default {
  data () {
    return {
      issue: {}
    }
  },
  mixins: [components],
  computed: {
    isAckButtonEnabled () {
      return !this.saving && this.issue && parseInt(this.issue.status) === this.STATUS_NOTACKNOWLEDGED
    }
  },
  methods: {
    loadIssue (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/issues/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject(e)
          return
        }
        this.loading = false
        this.issue = response.data
        resolve(response.data)
      })
    },
    getIssueType (type) {
      const _ = this._
      switch (type) {
        case 'netvisor':
          return _('Netvisor')
        case 'briox':
          return _('Briox')
        case 'nocfo':
          return _('NoCFO')
        case 'ropo':
          return _('Ropo')
        case 'email':
          return _('Email')
        case 'report':
          return _('Report')
        case 'generic':
          return _('Generic')
        case 'seam':
          return _('Seam')
        case 'payment':
          return _('Payment')
      }
      return type
    },
    close () {
      if (this.component && this.component.initData && this.component && this.component.initData.modal) {
        this.$emit('close')
      } else {
        this.EventBus.$emit('hideDetailsColumn', {
          shopId: this.shopId
        })
      }
    },
    async acknowledge () {
      this.saving = true
      const data = {
        id: this.issue.id,
        status: this.STATUS_ACKNOWLEDGED
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/issues/' + this.issue.id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      this.saving = false
      this.showNotification(this._('Changes saved successfully!'))
      this.close()
    },
    openRef () {
      if (this.issue && this.issue.ref) {
        switch (this.issue.reftype) {
          case 'bill':
            return this.openBill(this.issue.ref)
          case 'email':
            return this.displayMessage(this.issue.emailorder, this.issue.ref)
          case 'seamaccount':
            return this.openSmartDeviceSettings()
          case 'order':
            return this.openOrder(this.issue.ref)
        }
      }
    },
    openSmartDeviceSettings () {
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'SmartDeviceSettings',
        title: this._('Smart Devices'),
        initData: {
          activateTab: 'services'
        }
      })
    },
    openBill (id) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'InvoiceDetails',
        title: this._('Transaction') + ' ' + id,
        width: 6,
        data: {
          invoiceId: id,
          trail: this.componentTrail
        }
      })
    },
    openOrder (id) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'OrderDetails',
        title: this._('Order') + ' ' + id,
        width: 6,
        data: {
          orderId: id,
          trail: this.componentTrail
        }
      })
    },
    async displayMessage (orderId, messageIdentifier) {
      let response
      if (!orderId || !messageIdentifier) {
        return
      }
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/orders/' + orderId + '.json?message=' + messageIdentifier + '&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      const msg = response.data
      this.showModal('issuemessagedetails', SentMessageDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          originalMessage: msg
        },
        events: {},
        handlers: {},
        width: 800
      })
    }
  },
  created () {
    if (this.component && this.component.initData) {
      try {
        this.loadIssue(this.component.initData.issueId)
      } catch(e) {}
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.issue && this.issue.id && parseInt(this.issue.id, 10) !== parseInt(this.component.initData.issueId, 10)) {
        try {
          await this.loadIssue(this.component.initData.issueId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['issueUpdate'] = async (message) => {
        if (message && message.data && this.issue && parseInt(message.data.id, 10) === parseInt(this.issue.id, 10)) {
          try {
            await this.loadIssue(message.data.id)
          } catch(e) {}
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }  
}
</script>

<style scoped>
.bounce-detail {
  margin-bottom: 8px;
}
.bounce-detail:last-child {
  margin-bottom: 0;
}
/* Issue messages are raw API text and can carry newlines and XML tags */
.issue-message {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
